import React from 'react'
import cat1 from "../assets/images/cat1.webp"
import cat2 from "../assets/images/cat2.webp"
import cat3 from "../assets/images/3.webp"
import cat4 from "../assets/images/cat4.webp"
import bottom from "../assets/images/bottom.webp"
import pattern from "../assets/images/pattern.webp"
import lantern1 from "../assets/images/lantern1.webp"
import lantern2 from "../assets/images/lantern2.webp"
import lantern3 from "../assets/images/lantern3.webp"
import lantern4 from "../assets/images/lantern4.webp"
import meowth from "../assets/images/meowth.gif"
function Content() {
  return (
    <section className="w-full relative h-auto pt-20 min-h-screen font-primary text-white">
      <div className="grid grid-cols-4 right-0 left-0 mx-auto  bottom-0 absolute z-[-1] opacity-50">
        <img src={cat1} alt="" className="w-1/7  lg:block hidden"/>
        <img src={cat2} alt="" className="w-1/7 lg:block hidden"/>
        <img src={cat3} alt="" className="w-1/7 lg:block hidden"/>
        <img src={cat4} alt="" className="w-1/7 lg:block hidden"/>
      </div>
      <img src={bottom} alt="" className="w-full absolute top-0 z-[1]"/>
      <img src={pattern} alt="" className="w-full h-screen absolute object-cover z-[-1]"/>
      <img src={lantern1} className="absolute left-10 top-0 w-[5rem] lg:w-[15rem] opacity-30 xl:opacity-100 overflow-hidden pointer-events-none z-[-1]" />
      <img src={lantern2} className="absolute right-10 top-0 w-[5rem] lg:w-[10rem] opacity-30 xl:opacity-100 overflow-hidden pointer-events-none z-[-1]" />
      <img src={lantern3} className="absolute right-20 top-0 w-[5rem] lg:w-[10rem] opacity-30 xl:opacity-100 overflow-hidden pointer-events-none z-[-1]" />
      <img src={lantern4} className="absolute right-0 left-0 mx-auto top-0 w-[5rem] lg:w-[30rem] opacity-30 xl:opacity-100 overflow-hidden pointer-events-none z-[-1]" />
   
      {/* <div className="absolute w-full h-screen top-0 left-0 overflow-hidden z-10">
        <div className="absolute w-full h-screen" >
          <img src={meowth} alt="gold" className="w-16" />
        </div>
        <div className="absolute w-full h-screen" >
          <img src={meowth} alt="gold" className="w-12" />
        </div>
        <div className="absolute w-full h-screen" >
          <img src={meowth} alt="gold" className="w-12"/>
        </div>
        <div className="absolute w-full h-screen" >
          <img src={meowth} alt="gold" className="w-12" />
        </div>
        <div className="absolute w-full h-screen">
          <img src={meowth} alt="gold" className="w-16" />
        </div>
        <div className="absolute w-full h-screen" >
          <img src={meowth} alt="gold" className="w-12" />
        </div>
        <div className="absolute w-full h-screen">
          <img src={meowth} alt="gold" className="w-12" />
        </div>
        <div className="absolute w-full h-screen">
          <img src={meowth} alt="gold" className="w-12"/>
        </div>
      </div> */}

      <div className="my-container h-auto min-h-screen flex flex-col xl:flex-row h-auto justify-center items-center">
        <div className="w-full">
          <div >
            <img src={meowth} className="pointer-events-none mx-auto w-[10rem] lg:w-[20rem] lg:w-fit"/>
            </div>
            </div>
            <div className="w-full bg-orange-700/50 border-4 rounded-xl border-orange-200 drop-shadow-sm backdrop-blur-lg p-10">
            <div className="grid grid-cols-4 right-0 left-0 mx-auto  bottom-0 absolute block lg:hidden lg:z-[-1] opacity-50">
              <img src={cat1} className="w-1/7 "/>
              <img src={cat2} className="w-1/7"/>
              <img src={cat3} className="w-1/7"/>
              <img src={cat4} className="w-1/7"/>
            </div>
              <div >
                <h1 className="text-4xl lg:text-7xl text-center text-accent [text-shadow:-4px_3px_0px_#F3AB41]">Meowth ニャース</h1>
              </div>
              <div >
                <div className="flex font-secondary flex-col gap-y-5 text-lg text-white [text-shadow:-1px_3px_0px_#F3AB41] text-center lg:text-2xl">
                  <p className="">There is no night that does not end. Finally, after years of wait, the enigmatic allure of cats has pounced onto the Ethereum blockchain, transforming these magical creatures into the most powerful memes in the world! Imagine a realm where every feline frolic and mischievous meow is immortalized in the cryptoverse. Meowth is the symbol of change.</p>
                </div>
              </div>
              <div >
                <div className="flex max-w-[1600px]  relative flex-col items-center md:flex-row">
                  <div className="relative w-full items-center">
                    <h1 className="mt-20 text-5xl lg:text-9xl text-white font-primary [text-shadow:-3px_4px_0px_#F3AB41] text-center">TOKENOMICS</h1>
                    <div id="address" className="mx-auto">
                      <button className="px-2 py-3 border-solid border-[1px] border-accent/100 rounded-full bg-gradient-to-tr from-accent/10 to-accent/10 flex gap-x-3 items-center font-semibold z-50 hover:scale-[1.05] hover:from-accent/20  hover:to-accent/20 mx-auto mt-5 transition-all ease-in-out duration-300 text-[.6rem] lg:text-xl">
                        <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path></svg>
                        <p className="drop-shadow-lg text-accent ">0x00000000000000000000000000000000000000000</p>
                      </button>
                    </div>
                    <ul className="mt-5 flex flex-col items-center lg:flex-row lg:flex-grow gap-x-7 gap-y-5 lg:gap-x-0 lg:text-left text-center justify-center">
                      <li className="flex items-center">
                        <div className="">
                          <h2 className="text-3xl text-white text-center font-bold lg:text-2xl">0/0</h2>
                          <h4 className="max-w-[8.5rem] mx-auto text-center text-base opacity-50">Tax</h4>
                        </div>
                        <div className="mx-10 hidden h-full w-[1px] bg-white opacity-20 lg:block"></div>
                      </li>
                      <li className="flex items-center">
                        <div className="">
                          <h2 className="text-3xl text-white text-center font-bold lg:text-2xl">8,888,888,888</h2>
                          <h4 className="max-w-[8.5rem] mx-auto text-center text-base opacity-50">Supply</h4>
                        </div>
                        <div className="mx-10 hidden h-full w-[1px] bg-white opacity-20 lg:block"></div>
                      </li>
                      <li className="flex items-center">
                        <div className="">
                          <h2 className="text-3xl text-white text-center font-bold lg:text-2xl">Burnt</h2>
                          <h4 className="max-w-[8.5rem] mx-auto text-center text-base opacity-50">Liquidity</h4>
                        </div>
                        <div className="mx-10 h-full w-[1px] bg-white opacity-20 hidden lg:hidden"></div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
          </div>
        </div>
    </section>
  )
}

export default Content